// extracted by mini-css-extract-plugin
export default {"confirm-text":"Alerts_confirm-text__Ma6E3","modal-btns-container":"Alerts_modal-btns-container__sKCzu","modal-class":"Alerts_modal-class__pnT4C"};